import "../../styles/widgets/widgets.css";

const APPROVAL_LEVELS = {
    "admin": { title: "Approved by admin (central office)" },
    "reviewer": { title: "Approved by reviewer (central office)" },
    "province": { title: "Approved by province" },
    "default": { title: "Approved anonymously" }
};

export function ApprovalIcon({ approval }) {
    const classes = [ "approval-icon", approval ? approval.level : "admin" ];
    // const level = APPROVAL_LEVELS[approval.level] || APPROVAL_LEVELS.default;

    return <div className={classes.join(" ")} />;
}